import { DoorOpen } from "lucide-react";
import { Box, Button, Group, Switch, Text } from "@mantine/core";
import type { NearestExitKind } from "@/lib/api/client";
import { exitKind, nearestExitButtonLabel } from "@/lib/nearest-exit";

interface NearestExitControlProps {
  emergencyOnly: boolean;
  onEmergencyOnlyChange: (value: boolean) => void;
  /** Find the route; the page decides where it starts (the picked "Navigate from" room, else the member's own). */
  onFind: (kind: NearestExitKind) => void;
  pending: boolean;
  error: string | null;
}

/** "Nearest exit" strip above the member floorplan (#473): one tap draws the walking
 *  route to the nearest regular exit, or with the switch on, an emergency route: to the
 *  nearest exit of any kind, emergency exits included (stairs, never the lift). */
export function NearestExitControl({ emergencyOnly, onEmergencyOnlyChange, onFind, pending, error }: NearestExitControlProps) {
  const kind = exitKind(emergencyOnly);
  return (
    <Box px="sm" py={6} style={{ borderBottom: "1px solid var(--mantine-color-default-border)", flexShrink: 0 }}>
      <Group justify="space-between" gap="xs" wrap="nowrap">
        <Button
          size="compact-sm"
          color="green"
          leftSection={<DoorOpen size={14} />}
          onClick={() => onFind(kind)}
          disabled={pending}
        >
          {nearestExitButtonLabel(kind, pending)}
        </Button>
        <Switch
          size="sm"
          color="green"
          label="Emergency route"
          checked={emergencyOnly}
          onChange={(e) => onEmergencyOnlyChange(e.currentTarget.checked)}
          styles={{ label: { whiteSpace: "nowrap" } }}
        />
      </Group>
      {error && (
        <Text fz="xs" c="red" mt={4} role="alert">
          {error}
        </Text>
      )}
    </Box>
  );
}
